import { useState } from "react";
import MDCircularLoader from "components/MDCircularLoader";
import PlanNPayment from "../releases/components/PlanNPayment";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageShell from "components/common/PageShell";
import CreateEstimation from "./components/CreateEstimateModal";

const PREstimation = () => {
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const handleChange = (values: any) => {
    setOpen(values);
  };
  return (
    <>
      <DashboardNavbar />
      <PageShell>
        {loader && <MDCircularLoader startLoader overlayloader />}
        <PlanNPayment createEstimate={handleChange} />
      </PageShell>
      {open && <CreateEstimation values={open} onClose={() => setOpen(false)} />}
    </>
  );
};
export default PREstimation;
